<template>
  <div>
    <div class="top-bth">
      <el-button @click="add" size="small" type="primary">新增</el-button>
    </div>
    <div
      class="kqf-card mg10 pd10"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table
        border
        :data="datas.list"
        height="calc(100vh - 330px)"
        @sort-change="orderby"
      >
        <el-table-column label="ID" width="80" prop="id"></el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>
        <el-table-column label="所需积分" prop="score"></el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time_format"
        ></el-table-column>
        <el-table-column label="启用状态" prop="is_deleted">
          <template slot-scope="scope">
            <!-- <p v-if="scope.row.is_deleted == 1">+{{ scope.row.money }}</p>
            <p v-if="scope.row.entry_type == 2">-{{ scope.row.money }}</p> -->
            <el-switch
              v-model="scope.row.is_enable"
              :active-value="1"
              :inactive-value="0"
              @change="setEnable(scope.row.id, scope.$index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="updated_at">
          <template slot-scope="scope">
            <el-button
              @click="editPrize(scope.row)"
              type="text"
              style="margin-right: 10px"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定删除吗？"
              @confirm="deletePrize(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除 </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getIndex"
            :current-page="page"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--弹窗-->
    <el-dialog :title="dialogTitle" :visible.sync="isDialog" width="600px">
      <el-form label-width="100px" size="small">
        <el-form-item label="是否启用" required>
          <el-switch
            v-model="dialogData.is_enable"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="排序" required>
          <el-input
            @input="handleEdit"
            v-model="dialogData.sort"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="名称" required>
          <el-input v-model="dialogData.title" style="width: 220px" />
        </el-form-item>
        <el-form-item label="积分" required>
          <el-input
            @input="handleEdit2"
            v-model="dialogData.score"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="dialogTitle == '新增'"
            type="primary"
            @click="addSubmit"
            >确认</el-button
          >
          <el-button v-else type="primary" @click="editSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  prizeIndex,
  addPrize,
  editPrize,
  deletePrize,
  setEnable
} from "@/request/api/operation/operation";
export default {
  data() {
    return {
      loading: true,
      datas: [],
      dialogTitle: "新增",
      isDialog: false,
      dialogData: {
        is_enable: 1,
        title: "",
        sort: "",
        score: ""
      },
      page: 1,
      sort: ""
    };
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex(page) {
      this.page = page;
      prizeIndex({
        page: this.page,
        sort: this.sort
      }).then(res => {
        this.datas = res;
        this.loading = false;
      });
    },
    setEnable(id) {
      setEnable({
        id
      }).then(() => {
        this.$message({
          message: "成功",
          type: "success"
        });
      });
    },
    add() {
      this.dialogData = {
        is_enable: 1,
        title: "",
        sort: "",
        score: ""
      };
      this.dialogTitle = "新增";
      this.isDialog = true;
    },
    editPrize(item) {
      this.dialogData = JSON.parse(JSON.stringify(item));
      this.dialogTitle = "编辑";
      this.isDialog = true;
    },
    addSubmit() {
      addPrize(this.dialogData).then(() => {
        this.$message({
          message: "新增成功",
          type: "success"
        });
        this.isDialog = false;
        this.getIndex();
      });
    },
    editSubmit() {
      editPrize(this.dialogData).then(() => {
        this.$message({
          message: "编辑成功",
          type: "success"
        });
        this.isDialog = false;
        this.getIndex(this.page);
      });
    },
    deletePrize(id) {
      deletePrize({
        id
      }).then(() => {
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.getIndex();
      });
    },
    handleEdit(e) {
      let value = e.replace(/^(0+)|[^\d]+/g, ""); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, "$1"); // 最多保留15位整数
      this.dialogData.sort = value;
    },
    handleEdit2(e) {
      let value = e.replace(/^(0+)|[^\d]+/g, ""); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, "$1"); // 最多保留15位整数
      this.dialogData.score = value;
    },
    orderby(e) {
      if (e.order != null) {
        let order = e.order == "descending" ? "desc" : "asc";
        this.sort = e.prop + "_" + order;
      } else {
        this.sort = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style scoped>
.top-bth {
  display: flex;
  justify-content: flex-end;
  margin: 0 10px;
  padding: 0 10px;
}
</style>
